import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpJobs'

export const salaryInsightTextCreate  = (params = '') => Http.post('/salary-insight-texts', params)
export const salaryInsightTextsList   = (params = '') => Http.get(`/salary-insight-texts${serialize(params)}`)
export const salaryInsightTextByID    = (params = '') => Http.get(`/salary-insight-texts/${params}`)
export const salaryInsightTextUpdate  = (params = '') => Http.put(`/salary-insight-texts/${params.id}`, params)
export const salaryInsightTextDestroy = (params = '') => Http.delete(`/salary-insight-texts/${params.id}`)
